// import api from "../../../interceptor/Interceptor";
// import { ORG_GET, ORG_UPDATE, ORG_DEACTIVATE, FILE_UPLOAD_URL, FILE_DELETE } from "../../../api/ApiEndpoints";
// import {
//   fetchOrgStart,
//   fetchOrgSuccess,
//   fetchOrgFailure,
//   updateOrgStart,
//   updateOrgSuccess,
//   updateOrgFailure,
//   deactivateOrgStart,
//   deactivateOrgSuccess,
//   deactivateOrgFailure,
//   setLogoBusy,
// } from "../../reducer/organizationReducer/OrganizationReducer";

// const extractErrorMessage = (error, fallback) =>
//   error?.response?.data?.error?.message ||
//   error?.response?.data?.message ||
//   error?.message ||
//   fallback;

// // .................... Fetch / Update / Deactivate ...........................

// export const fetchOrgInfo = () => async (dispatch) => {
//   dispatch(fetchOrgStart());
//   try {
//     const response = await api.get(ORG_GET);
//     const org = response.data.organization || {};
//     const info = {
//       name: org.name || "",
//       premiumMember: org.premiumMember,
//       isActive: org.isActive,
//       createdAt: org.createdAt,
//       accountLogoUrl: org.accountLogoUrl,
//       poLogoUrl: org.poLogoUrl,
//       address: org.address || "",
//       taxId: org.taxId || "",
//     };
//     dispatch(fetchOrgSuccess(info));
//     return { success: true, info };
//   } catch (error) {
//     const message = extractErrorMessage(error, "Failed to fetch organization info");
//     dispatch(fetchOrgFailure(message));
//     return { success: false, error: message };
//   }
// };

// export const updateOrgInfo = (orgInfo) => async (dispatch) => {
//   dispatch(updateOrgStart());
//   try {
//     await api.put(ORG_UPDATE, orgInfo);
//     dispatch(updateOrgSuccess(orgInfo));
//     return { success: true };
//   } catch (error) {
//     const message = extractErrorMessage(error, "Failed to update organization");
//     dispatch(updateOrgFailure(message));
//     return { success: false, error: message };
//   }
// };

// export const deactivateOrg = () => async (dispatch) => {
//   dispatch(deactivateOrgStart());
//   try {
//     await api.post(ORG_DEACTIVATE);
//     dispatch(deactivateOrgSuccess());
//     return { success: true };
//   } catch (error) {
//     const message = extractErrorMessage(error, "Failed to deactivate organization");
//     dispatch(deactivateOrgFailure(message));
//     return { success: false, error: message };
//   }
// };


// const busyKeyFor = (fileName, action) => {
//   const kind = fileName === "main-logo" ? "MainLogo" : "PoLogo";
//   return `${action}${kind}`; // e.g. "uploadingMainLogo", "removingPoLogo"
// };

// export const uploadOrgLogo = (file, fileName, organizationId) => async (dispatch) => {
//   const busyKey = busyKeyFor(fileName, "uploading");
//   dispatch(setLogoBusy({ key: busyKey, value: true }));
//   try {
//     const fileKey = `org-images/${organizationId}/${fileName}`;
//     const uploadRes = await api.get(`${FILE_UPLOAD_URL}?fileName=${encodeURIComponent(fileKey)}&fileType=${file.type}`);
//     const { uploadUrl } = uploadRes.data;

//     const putResponse = await fetch(uploadUrl, {
//       method: "PUT",
//       headers: { "Content-Type": file.type },
//       body: file,
//     });
//     if (!putResponse.ok) throw new Error(`Upload failed with status ${putResponse.status}`);

//     return { success: true };
//   } catch (error) {
//     const message = extractErrorMessage(error, "Failed to upload organization logo");
//     return { success: false, error: message };
//   } finally {
//     dispatch(setLogoBusy({ key: busyKey, value: false }));
//   }
// };

// export const removeOrgLogo = (fileName, organizationId) => async (dispatch) => {
//   const busyKey = busyKeyFor(fileName, "removing");
//   dispatch(setLogoBusy({ key: busyKey, value: true }));
//   try {
//     const fileKey = `org-images/${organizationId}/${fileName}`;
//     await api.post(`${FILE_DELETE}?fileKey=${encodeURIComponent(fileKey)}`);
//     return { success: true };
//   } catch (error) {
//     const message = extractErrorMessage(error, "Failed to remove organization logo");
//     return { success: false, error: message };
//   } finally {
//     dispatch(setLogoBusy({ key: busyKey, value: false }));
//   }
// };


















import { ORG_GET, ORG_DEACTIVATE, FILE_UPLOAD_URL, FILE_DELETE } from "../../../api/ApiEndpoints";
import api from "../../../interceptor/Interceptor";
import {
  fetchOrgStart,
  fetchOrgSuccess,
  fetchOrgFailure,
  updateOrgStart,
  updateOrgSuccess,
  updateOrgFailure,
  deactivateOrgStart,
  deactivateOrgSuccess,
  deactivateOrgFailure,
  uploadLogoStart,
  uploadLogoSuccess,
  uploadLogoFailure,
  removeLogoStart,
  removeLogoSuccess,
  removeLogoFailure,
} from "../../reducer/organizationReducer/OrganizationReducer";

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || error?.error || fallback;

// .................... Fetch / Update / Deactivate ...........................

export const fetchOrganization = () => async (dispatch) => {
  dispatch(fetchOrgStart());
  try {
    const response = await api.get(ORG_GET);
    dispatch(fetchOrgSuccess(response.data.organization));
    return { success: true, organization: response.data.organization };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to fetch organization info");
    dispatch(fetchOrgFailure(message));
    return { success: false, error: message };
  }
};

export const updateOrganization = (orgData) => async (dispatch) => {
  dispatch(updateOrgStart());
  try {
    await api.put(ORG_GET, orgData);
    dispatch(updateOrgSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to update organization");
    dispatch(updateOrgFailure(message));
    return { success: false, error: message };
  }
};

export const deactivateOrganization = () => async (dispatch) => {
  dispatch(deactivateOrgStart());
  try {
    await api.post(ORG_DEACTIVATE);
    dispatch(deactivateOrgSuccess());
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to deactivate organization");
    dispatch(deactivateOrgFailure(message));
    return { success: false, error: message };
  }
};

// .................... Logo upload / remove ...........................
// `key` is "mainLogo" | "poLogo" (drives the per-logo loading sub-state).
// `fileName` is the actual S3 key suffix ("main-logo" | "purchase-order-logo").

export const uploadOrgLogo = (file, key, fileName, organizationId) => async (dispatch) => {
  dispatch(uploadLogoStart(key));
  try {
    const uploadRes = await api.get(
      `${FILE_UPLOAD_URL}?fileName=${encodeURIComponent(`org-images/${organizationId}/${fileName}`)}&fileType=${file.type}`,
    );
    const { uploadUrl } = uploadRes.data;

    const putRes = await fetch(uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": file.type },
      body: file,
    });
    if (!putRes.ok) throw new Error(`Upload failed with status ${putRes.status}`);

    dispatch(uploadLogoSuccess(key));
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to upload logo");
    dispatch(uploadLogoFailure({ key, error: message }));
    return { success: false, error: message };
  }
};

export const removeOrgLogo = (key, fileName, organizationId) => async (dispatch) => {
  dispatch(removeLogoStart(key));
  try {
    await api.post(
      `${FILE_DELETE}?fileKey=${encodeURIComponent(`org-images/${organizationId}/${fileName}`)}`,
    );
    dispatch(removeLogoSuccess(key));
    return { success: true };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to remove logo");
    dispatch(removeLogoFailure({ key, error: message }));
    return { success: false, error: message };
  }
};